import { render, staticRenderFns } from "./AccountSettingsTab.vue?vue&type=template&id=a5047090"
import script from "./AccountSettingsTab.vue?vue&type=script&lang=js"
export * from "./AccountSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsTab.vue?vue&type=style&index=0&id=a5047090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports